import { render, staticRenderFns } from "./approvalFiles.vue?vue&type=template&id=b2314820&scoped=true&"
import script from "./approvalFiles.vue?vue&type=script&lang=js&"
export * from "./approvalFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2314820",
  null
  
)

export default component.exports